import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type RingSearchProps = {
    className?: string;
};

const RingSearch: FunctionComponent<RingSearchProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'ring-search'}
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
        >
            <path d="M233.4 93.5l-21.8-20.1-8.3-7.6c5.6-6.6 8.7-14.8 8.7-23.4 0-20.1-17-36.6-37.8-36.6-11.9 0-22.6 5.3-29.5 13.7-.1.2-.3.3-.4.5-.1.2-.3.3-.4.5-2 2.6-3.7 5.5-4.9 8.5-.1.2-.1.3-.2.5s-.1.3-.2.5c-1.4 3.9-2.2 8-2.2 12.4 0 17.4 12.6 31.9 29.5 35.5.2 0 .3.1.5.1s.3.1.5.1c2.4.5 4.8.7 7.3.7h2.1c7.9-.4 15.1-3.2 21-7.6l8.3 7.7 22 20.4c.8.7 1.8 1.2 2.9 1.2 1.1 0 2.2-.4 3-1.3 1.5-1.6 1.5-4.1-.1-5.7zm-57.2-22.7h-2c-2.6 0-5.1-.3-7.4-.9-.2 0-.3-.1-.5-.1s-.3-.1-.5-.1c-12.2-3.5-21.1-14.5-21.1-27.3 0-4.4 1.1-8.6 2.9-12.4.1-.2.2-.3.3-.5.1-.2.2-.3.3-.5 1.8-3.3 4.3-6.2 7.2-8.5.2-.2.4-.3.7-.5.2-.2.4-.3.7-.5 4.9-3.5 11-5.6 17.6-5.6 16.3 0 29.6 12.8 29.6 28.5-.2 15-12.5 27.4-27.8 28.4z" />
            <path
                d="M49.1 163.7c0 34.3 27.9 62.2 62.2 62.2 34.3 0 62.2-27.9 62.2-62.2 0-34.3-27.9-62.2-62.2-62.2-34.3-.1-62.2 27.8-62.2 62.2zm116.5-.1c0 29.9-24.3 54.2-54.2 54.2-29.9 0-54.2-24.3-54.2-54.2 0-29.9 24.3-54.2 54.2-54.2 29.8-.1 54.2 24.3 54.2 54.2z"
                className="st0"
            />
            <path
                d="M140.4 76.2l-10.3 11.2c-1.1-.2-2.1-.5-3.2-.7L136 71c-2.4-3.3-4.4-7-6-10.8H71.2l18.8-18h36.5v-.7c0-2.4.2-4.8.5-7.1H86.8L57.6 62.3l27.9 28.3.3.3c-30.9 10.9-51.5 39.9-51.5 72.7 0 42.5 34.6 77.1 77.1 77.1 42.5 0 77.1-34.6 77.1-77.1 0-33.3-21-62.5-52.5-73.1l9.6-9.7c-1.9-1.4-3.6-2.9-5.2-4.6zm-11.8-8.1l-10.2 17.6c-5-.4-9.8-.4-14.8.1L93 68.1h35.6zm-54.9 0h10.1l11.4 19c-1.3.3-2.3.5-3.1.7h-.2L73.7 68.1zm106.7 95.6c0 38.1-31 69.1-69.1 69.1-38.1 0-69.1-31-69.1-69.1s31-69.1 69.1-69.1c38.1 0 69.1 31 69.1 69.1z"
                className="st0"
            />
        </svg>
    );
};

export default RingSearch;
